import React from 'react';
import styles from "./Loader.module.scss";

const Loader = () => {
  return (
    <div className={styles.loaderWrapper}>
      <div className={styles.loaderContainer}>
        <div className={styles.loader}>
          <div className={styles.loaderInner}>
            <div className={styles.loaderLineWrap}>
              <div className={styles.loaderLine}></div>
            </div>
            <div className={styles.loaderLineWrap}>
              <div className={styles.loaderLine}></div>
            </div>
            <div className={styles.loaderLineWrap}>
              <div className={styles.loaderLine}></div>
            </div>
          </div>
        </div>
        <div className={styles.loaderText}>
          <span>L</span>
          <span>o</span>
          <span>a</span>
          <span>d</span>
          <span>i</span>
          <span>n</span>
          <span>g</span>
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;